module.exports = __webpack_public_path__ + "img/horizontal_6_5_3009.e67e551e.png";